import React from 'react';
import QRCode from 'react-qr-code';

// QR-Code for the app with proper URL formatting
const QRCodePlaceholder = ({ sessionId, size = 192 }) => {
  // Build play URL from origin (not current path)
  const origin = window.location.origin;
  // Use /play route for student access
  const playUrl = `${origin}/play/${sessionId}`;

  return (
    <div className="flex items-center justify-center">
      <div className="text-center">
        <QRCode value={playUrl} size={size} />
      </div>
    </div>
  );
};

export default QRCodePlaceholder;